import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/common.service'
import { APIService } from '../../api.service';
import { DataService } from '../../services/data.service'
import { MultipleSelectItemComponent } from '../../inventory/multiple-select-item/multiple-select-item.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-material-consumption',
  templateUrl: './material-consumption.component.html',
  styleUrls: ['./material-consumption.component.scss']
})
export class MaterialConsumptionComponent implements OnInit {
  items: any = [];
  jobDetails: any = [];
  productItems: any = [];
  jobItems: any = [];
  generationList:any = [];
  isWeb: boolean = true;
  editIndex: number = -1;
  changeQty: number = 0;
  isShowDel: boolean = false;
  @Input() prTypeID: number = 1;
  @Output() onMtlConsChange: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(private router: Router, public commonFun: CommonService, private apiService: APIService,
    private dataSer: DataService, private modalService: NgbModal, private cd: ChangeDetectorRef) {

      this.dataSer.items.subscribe((value: any) => {

      if(value && value.length > 0) {
        if(value[0].Bom == true) {
        this.prductData.bom = [];
        }
      }
      if (value.length > 0) {
        this.items = value;
          let selecetdItems = value;
          
          for (let i = 0; i < selecetdItems.length; i++) {
            let tempData = this.prductData.bom.filter((x: any) => x.ItemID == selecetdItems[i].ItemID)
            if (tempData.length == 0) {
            this.prductData.bom.push({
              ItemID: selecetdItems[i].ItemID ? selecetdItems[i].ItemID : selecetdItems[i].MID,
              ReqdQty: '',
              usedQty: Number(selecetdItems[i].UsedQty ? Number(selecetdItems[i].UsedQty).toFixed(selecetdItems[i].Prcsn) : Number(0).toFixed(selecetdItems[i].Prcsn)),
              TypeID: 1,
              Unit: selecetdItems[i].SKU,
              productName: selecetdItems[i].ItemName,
              productCode: (selecetdItems[i].ItemCode ? selecetdItems[i].ItemCode : ''),
              DefStockRate: selecetdItems[i].DefStockRate ? selecetdItems[i].DefStockRate : 0,
              DoneQty: selecetdItems[i].DoneQty ? Number(selecetdItems[i].DoneQty).toFixed(selecetdItems[i].Prcsn) : Number(0).toFixed(selecetdItems[i].Prcsn),
              PQty: Number(selecetdItems[i].PQty ? Number(selecetdItems[i].PQty).toFixed(selecetdItems[i].Prcsn) : Number(0).toFixed(selecetdItems[i].Prcsn)),
              SKU: selecetdItems[i].SKU ? selecetdItems[i].SKU : '',
              issueQty: selecetdItems[i].issueQty ? Number(selecetdItems[i].issueQty).toFixed(selecetdItems[i].Prcsn) : 0,
              StrQty: selecetdItems[i].StrQty ? Number(selecetdItems[i].issueQty).toFixed(selecetdItems[i].Prcsn) : 0,
              ValStdCost: selecetdItems[i].ValStdCost ? selecetdItems[i].ValStdCost : 0,
              IsSelect: selecetdItems[i].isSelected ? selecetdItems[i].isSelected : false,
              CurrQty: selecetdItems[i].CurrQty ? Number(selecetdItems[i].CurrQty).toFixed(selecetdItems[i].Prcsn): 0,
              Prcsn: selecetdItems[i].Prcsn,
              Details: selecetdItems[i].Details || '',
            });
          }
          let temBOMData = this.prductData.bom.filter((x: any) => x.usedQty == 0 && x.IsSelect == false)
          if(temBOMData.length > 0){
            this.isShowDel = true;
          }

          if (selecetdItems.length > 0) {
            this.onMtlConsChange.emit(true);
          }
          // this.prductData.bom.forEach((b: any) => {

          // });
        }
        this.getItems();
        this.prductData.bom = this.prductData.bom.sort((a: any, b: any) => a.productName.localeCompare(b.productName))
        // this.dataSer.updateItems(this.items);
        // console.log('this.prductData.bom', this.prductData.bom);
      }
      else{
        this.prductData.bom = [];
      }
    });


    this.dataSer.WIPDetails.subscribe((value: any) => {
      if (value) {
        this.jobDetails = value.Table1;
        if( this.jobDetails ){
        this.productItems = JSON.parse(this.jobDetails[0].Generation)
      }
        this.jobItems = value.Table2;
      }
    });

  }


  getItems(){
    if(this.jobDetails.length > 0 ){

    let tempData = JSON.parse(this.jobDetails[0].Consumption)
    for(let i = 0; i < tempData.length ; i++){
      for(let x = 0;x < this.prductData.bom.length ; x++ )
      if(tempData[i].MID == this.prductData.bom[x].ItemID ){
        this.prductData.bom[x].PQty = Number(tempData[i].PQty).toFixed(this.prductData.bom[x].Prcsn);
      }
    }
  }

  }

  

  //#region "Declaration"
  @Input() Data: any;
  @Input() mdlRef: any;
  prductData: any = {
    productID: 0,
    productName: 'Blue LED Light',
    bom: []
  }

  modalReference: any;
  jarvisData: any = [];

  products: any = [];
  agencyData: any = [];

  isEdit: boolean = false;




  //#endregion

  ngOnInit(): void {
    // let productID = this.commonFun.GetParam("PID");
    // this.prductData.productID = productID;
    this.apiService.getIDB('erp_inv', (productList: any) => {
      if (productList && productList.length > 0) {
        this.products = productList;
      }else {
        this.apiService.fetchERPStockItems('RESET', (res: any) => {
            if(res && res.length > 0) {
              this.products = res;
            }
        });
      }
    });

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.isWeb = this.apiService.apiCheckWeb();

  }
  isSelectedItem = false;
  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass: "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.it = this.prductData.bom.map((a: any) => a.ItemID);
    // this.modalReference.componentInstance.st = this.frmStore.id;
    this.modalReference.componentInstance.stc = 0;
    this.modalReference.componentInstance.ft = 0;
    this.modalReference.componentInstance.isMade = 1;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.isSelectedItem= true;
    
    
  }


  closeModal() {
    this.modalReference.close();
  }


  //failureBOMResp - failure handler
  failureBOMResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successBOMEntry - success  get handler
  successBOMEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          alert(reponseData.Table[0].ErrMsg);
        }
        else {
          // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductData.productID);
          if (this.mdlRef) {
            this.mdlRef.close('Done');
          }

          this.isEdit = false;
        }
      }
    }
  }

  goBack() {
    this.mdlRef.close('Close');
    this.dataSer.updateBOMData(this.prductData.bom);
  }


  removeBOM(ind: number) {
    var r = confirm("Are you sure you want to delete this item?");
    if (r == true) {
      this.prductData.bom.splice(ind, 1);
      this.save()
    }
  }
  
  editQty(obj:any, i:number){
    obj.IsSelect = true;
    obj.tmpQty = obj.PQty;
    if(obj.tmpQty == 0){
      this.prductData.bom[i].PQty = '';
    }
    
    if(this.prductData.bom[i].ReqdQty == 0){
      this.prductData.bom[i].ReqdQty = "";
    }
    

    // this.editIndex  = i;

  }

  cancel(obj: any) {
    obj.IsSelect = false;
    obj.PQty = obj.tmpQty;
  }


  save() {
    let generationList: any = [];
    
    for (let i = 0; i < this.productItems.length; i++) {
     
      let obj = {
        ItemID: this.productItems[i].PID,
        PlanQty: this.productItems[i].PQty + '',
        DoneQty:  this.productItems[i].GenQty + '',
        XnIDs: this.productItems[i].XnIDs,
        Description: this.productItems[i].D ? this.productItems[i].D : '',
      }
      generationList.push(obj);
    }

    let ConsumptionList: any = [];
    for (let i = 0; i < this.prductData.bom.length; i++) {
      let obj = {
        ItemID: this.prductData.bom[i].ItemID,
        PlanQty: this.prductData.bom[i].PQty + '',
        DoneQty:  this.prductData.bom[i].usedQty + '',
        XnIDs: '',
        Description: this.prductData.bom[i].Details || '',
      }
      ConsumptionList.push(obj);
    }

    if (this.jobDetails[0]?.Consumption) {
      this.jobDetails[0].Consumption = JSON.stringify(ConsumptionList);
    }

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

    var tempData = [{
      'JobID': this.jobDetails[0].JobID,
      'TargetDT': this.jobDetails[0].TargetDT, //new Date(),
      'Stages': this.jobDetails[0].Stages,
      'Generation': JSON.stringify(generationList),
      'Consumption': JSON.stringify(ConsumptionList),
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setDetail',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successVchrEntry.bind(this), this.failureResp.bind(this));

  }

  //successVchrEntry - success voucher entry handler
  successVchrEntry(res: any) {
    // this.closeModel();
    if (res.error) {
    }
    else {
    
      this.prductData.bom.forEach((a:any) => {
        a.IsSelect = false
      });

      let doneObj = {
        action: 'Done',
        obj: res,
      }

      if (this.prductData.bom.length == 0) {
        this.cd.detectChanges();
        this.onMtlConsChange.emit(false);
      }

    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
    // this.closeModel();
    let doneObj = {
      action: 'Close',
      obj: null
    }
    this.mdlRef.close(doneObj);
  }

  openTransaction(obj:any) {
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open('transactionJobs;id=' + obj +';jobID=' +  this.jobDetails[0].JobID + ";pTID=" + this.prTypeID , target);
  }

  checkPrecision(obj: any) {
    obj.PQty = this.commonFun.PrecisionwiseValue(obj.PQty, obj.Prcsn);
  }




}
